import React, { useMemo } from "react";
import "./common.css";
import { useHistory, useLocation } from "react-router-dom";

interface NavItem {
  name: string;
  pathname: string;
  descriptor?: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

interface NewNavLinkSidebarProps {
  item: NavItem;
  onClick?: () => void;
}

const NewNavLinkSidebar: React.FC<NewNavLinkSidebarProps> = ({
  item,
  onClick,
}) => {
  const location = useLocation();
  const history = useHistory();
  const isSelected = useMemo(
    () => location?.pathname === item?.pathname,
    [location, item],
  );
  const Icon = item.icon;

  const handleNavClick = () => {
    if (typeof onClick === "function") {
      onClick();
    } else {
      history.push(item?.pathname);
    }
  };

  return (
    <div
      className={`sidebar-nav-link-container ${isSelected ? "selected" : ""}`}
      onClick={handleNavClick}
    >
      <Icon className="sidebar-nav-icon" />
      <div className="sidebar-nav-text-container">
        <span
          className={`sidebar-nav-link-text ${isSelected ? "selected" : ""}`}
        >
          {item.name}
        </span>
        {item.descriptor && (
          <span className="sidebar-nav-descriptor">{item.descriptor}</span>
        )}
      </div>
    </div>
  );
};

export default NewNavLinkSidebar;
